import { transformSchemaProduct } from "library/utils/shopify/transform/schema";
interface P {
  locale: string;
  shopifyProduct: any;
}

const ProductSchema: React.FC<P> = ({ locale, shopifyProduct }: P) => {
  const schema = transformSchemaProduct(locale, shopifyProduct);
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(schema, null, 2),
      }}
    ></script>
  );
};
export default ProductSchema;
